module.exports = __webpack_public_path__ + "static/media/order_receipt.6166a8c5.png";